import React, { useEffect, useState } from "react";
import { VolumeX } from "lucide-react";

// Facebook/TikTok-style "sound off" signal. Renders ONLY while the video is muted;
// tapping it enables sound. Position is provided by the parent via `className`.
//   variant="full"    (full-screen pages) → expands with a label for a few seconds,
//                       then collapses to a compact speaker-off icon.
//   variant="compact" (feed previews) → always a small icon + short label.
export const SoundIndicator = ({
  muted,
  onEnable,
  className = "",
  label = "Appuyez pour le son",
  testId = "sound-indicator",
  variant = "full",
}) => {
  const compact = variant === "compact";
  const [expanded, setExpanded] = useState(true);
  useEffect(() => {
    if (compact || !muted) return;
    setExpanded(true);
    const tmr = setTimeout(() => setExpanded(false), 3500);
    return () => clearTimeout(tmr);
  }, [muted, compact]);
  if (!muted) return null;
  const showLabel = compact || expanded;
  const pad = compact ? "px-2.5 py-1" : (expanded ? "px-4 py-2 text-sm" : "px-2.5 py-2.5");
  const iconSize = compact ? 14 : (expanded ? 16 : 18);
  return (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); onEnable?.(); }}
      className={`flex items-center gap-1.5 rounded-full text-white font-semibold shadow-lg transition-all duration-300 active:scale-95 ${compact ? "text-[11px]" : ""} ${pad} ${className}`}
      style={{ background: "rgba(0,0,0,0.62)", backdropFilter: "blur(6px)", border: "1px solid rgba(255,255,255,0.2)" }}
      data-testid={testId}
      aria-label={label}
    >
      <VolumeX size={iconSize} className="shrink-0" />
      {showLabel && <span className="whitespace-nowrap">{label}</span>}
    </button>
  );
};

export default SoundIndicator;
